// main.js

import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/routes/index.js'; // Import the router configuration file

createApp(App)
  .use(router) // Use Vue Router
  .mount('#app');
